// payroll-misc-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'r1l.pension.org': 'Org. {org}',
  'r1l.pension.voucherInline': 'Bilag {voucher}',
  'r1l.pension.employeesInline': '{count} ansatte',
  'r1l.run.salaryTo': 'Lønn til {name}',
  'r1l.holiday.paidShort': 'Utbet.:',
  'r1l.overview.holidayPayShort': 'FP:',
  'r1l.dialogs.correctionHint': 'Bruk korrigeringsikonet ved beløpet for å justere utbetalingen, f.eks. hvis det ikke er nok penger på konto til å betale ut alt.',
  'r1l.shared.addAccount': '+ Legg til konto',
  'r1l.tax.agaNote': 'Arbeidsgiveravgift betales samlet per termin. Pensjonspremie tas med i terminen den faktisk er betalt.',
  'r1l.tax.partialNote': 'Delbetaling fordeles forholdsmessig mellom forskuddstrekk og arbeidsgiveravgift.',
  'r1l.tax.annulledNote': 'Annullerte betalinger beholdes ikke i saldobalansen.',
  'r1l.employee.saved': 'Ansatt lagret.',
});
